/** Add presentation hints without replacing cells or their interactive controls. */
export function enhancePortalTable(table: HTMLTableElement, labels: string[]) {
  // Public Resources and SHVR Progress retain their original responsive layouts.
  if (table.matches('.resources-table, .progress-status-table')) {
    table.classList.remove('portal-card-table');
    delete table.dataset.cardLayout;
    table.querySelectorAll('[data-card-field]').forEach(cell => cell.removeAttribute('data-card-field'));
    return false;
  }
  if (!table.closest('.dashboard-wrapper, .school-portal')) return false;
  const header = table.tHead?.rows.item((table.tHead?.rows.length || 1) - 1);
  if (header) labels = Array.from(header.cells).flatMap(cell => Array(cell.colSpan).fill(cell.innerText.trim()));
  table.classList.add('portal-card-table');
  const serial = /^(s\.?\s*no\.?|sr\.?\s*no\.?|serial.*|#)$/i;
  const action = /action|download|certificate/i;
  const identity = /name|school|state|district|region|report|category|title/i;
  const titleIndex = labels.findIndex(label => identity.test(label) && !/count|total|status|number|assigned|initiated|completed|rating/i.test(label));
  table.dataset.cardLayout = labels.length > 8 ? 'wide' : 'compact';
  Array.from(table.tBodies).forEach(body => {
    Array.from(body.rows).forEach(row => {
      let column = 0;
      Array.from(row.cells).forEach(cell => {
        const label = labels[column] || '';
        const index = column;
        column += cell.colSpan;
        cell.removeAttribute('data-card-field');
        if (cell.colSpan > 1 && row.cells.length === 1) {
          cell.dataset.cardField = 'message';
          cell.dataset.responsiveFullWidth = 'true';
          cell.removeAttribute('data-label');
          return;
        }
        cell.removeAttribute('data-responsive-full-width');
        cell.dataset.label = label;
        if (serial.test(label) || (!label && cell.querySelector('input[type="checkbox"]'))) {
          cell.dataset.cardField = 'serial';
        } else if (index === titleIndex) {
          cell.dataset.cardField = 'title';
        } else if (action.test(label) || (!label && cell.querySelector('button, a[download]'))) {
          cell.dataset.cardField = 'actions';
        } else if (cell.colSpan > 1 || /email|address|department|remark|requirement|evaluator details/i.test(label)) {
          cell.dataset.cardField = 'wide';
        } else if (/rating|percentage|score/i.test(label)) {
          cell.dataset.cardField = 'metric';
        }
      });
    });
  });
  return true;
}
